import { ClassNames } from "@emotion/core";
import { color as colorFunction } from "@smartsheet/design-tokens-react";
import React from "react";
import { useTheme } from "../../theme/utils/useTheme";
import * as Theme from "../tag/TagTheme";
import { CloseButton, CloseRestSvg, CloseHoverSvg } from "./styled/CloseButton";
import { TokenContainer } from "./styled/TokenContainer";
import { TokenImageContainer } from "./styled/TokenImageContainer";
import { TokenLabel } from "./styled/TokenLabel";
export const Token = _ref => {
  let {
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-describedby": ariaDescribedBy,
    image,
    color = "blueLight",
    children,
    className,
    onCloseSelected,
    clientId,
    onMouseDown,
    isDisabled = false
  } = _ref;
  const {
    key
  } = useTheme();
  const theme = key;
  let backgroundColor, textColor;
  if (isDisabled) {
    backgroundColor = colorFunction("color--background--neutral--default");
    textColor = colorFunction("color--text--neutral--weaker");
  } else if (typeof color === "string") {
    backgroundColor = Theme.backgroundColor(color, theme);
    textColor = colorFunction("color--text--neutral--strong");
  } else {
    ({
      backgroundColor,
      textColor
    } = color);
  }
  return /*#__PURE__*/React.createElement(TokenContainer, {
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-describedby": ariaDescribedBy,
    backgroundColor: backgroundColor,
    textColor: textColor,
    className: className,
    "data-client-id": clientId,
    onMouseDown: onMouseDown,
    "aria-disabled": isDisabled || undefined
  }, image && /*#__PURE__*/React.createElement(TokenImageContainer, {
    "aria-hidden": true
  }, image), /*#__PURE__*/React.createElement(TokenLabel, null, children), /*#__PURE__*/React.createElement(ClassNames, null, _ref2 => {
    let {
      css,
      cx
    } = _ref2;
    return /*#__PURE__*/React.createElement(CloseButton, {
      "aria-label": `Remove ${children}`,
      "aria-disabled": isDisabled,
      onClick: isDisabled ? undefined : onCloseSelected,
      themeMode: theme,
      isDisabled: isDisabled,
      type: "button"
    }, !isDisabled && /*#__PURE__*/React.createElement(CloseHoverSvg, {
      className: cx("token--icon--hover", css`
                                            display: none;
                                        `)
    }), /*#__PURE__*/React.createElement(CloseRestSvg, {
      className: "token--icon-rest"
    }));
  }));
};
//# sourceMappingURL=Token.js.map